// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.container-logo[data-v-12f5a4ba] {\r\n  flex-direction: column;\n}\n.maxSizingProgress[data-v-12f5a4ba] {\r\n  display: flex;\r\n  justify-content: center;\n}\r\n", ""]);
// Exports
module.exports = exports;
